import React, { useState } from 'react';
import { CreditCard } from 'lucide-react';

function AddSubscriptionModal({ onClose, onAdd }) {
  const [form, setForm] = useState({ name: '', email: '', plan: 'Pro Racer', billing: 'Monthly' });

  const planPrices = {
    'Starter':    { Monthly: 9,   Annual: 86  },
    'Pro Racer':  { Monthly: 29,  Annual: 278 },
    'Champion':   { Monthly: 59,  Annual: 566 },
  };

  const handleSubmit = () => {
    if (!form.name || !form.email) return alert('Please fill all fields.');
    const price = planPrices[form.plan][form.billing];
    const today = new Date();
    const expiry = new Date(today);
    if (form.billing === 'Monthly') expiry.setMonth(expiry.getMonth() + 1);
    else expiry.setFullYear(expiry.getFullYear() + 1);

    const fmt = d => d.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });

    onAdd({
      id: `#SUB${String(Math.floor(Math.random() * 900) + 100)}`,
      name: form.name,
      email: form.email,
      plan: form.plan,
      billing: form.billing,
      start: fmt(today),
      expiry: fmt(expiry),
      amount: `$${price.toFixed(2)}`,
      status: 'Active',
    });
    onClose();
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: 16,
    }}>
      <div className="card animate-in" style={{ width: '100%', maxWidth: 480, maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h2 className="font-heading" style={{ fontSize: 20 }}>Add New Subscription</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: 20 }}>✕</button>
        </div>
        <div className="form-group">
          <label className="form-label">Full Name</label>
          <input className="form-control" placeholder="Enter full name"
            value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} />
        </div>
        <div className="form-group">
          <label className="form-label">Email</label>
          <input className="form-control" type="email" placeholder="user@email.com"
            value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} />
        </div>
        <div className="form-group">
          <label className="form-label">Plan</label>
          <select className="form-control" value={form.plan} onChange={e => setForm(p => ({ ...p, plan: e.target.value }))}>
            <option>Starter</option>
            <option>Pro Racer</option>
            <option>Champion</option>
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Billing Cycle</label>
          <select className="form-control" value={form.billing} onChange={e => setForm(p => ({ ...p, billing: e.target.value }))}>
            <option>Monthly</option>
            <option>Annual</option>
          </select>
        </div>

        {/* Price preview */}
        <div style={{
          padding: '12px 16px', borderRadius: 8, background: 'rgba(232,0,29,0.06)',
          border: '1px solid rgba(232,0,29,0.2)', marginBottom: 16,
          display: 'flex', justifyContent: 'space-between',
        }}>
          <span style={{ color: 'var(--text-muted)', fontSize: 13 }}>Amount</span>
          <span className="font-heading" style={{ color: 'var(--text-primary)', fontSize: 16 }}>
            ${planPrices[form.plan][form.billing].toFixed(2)} / {form.billing === 'Monthly' ? 'mo' : 'yr'}
          </span>
        </div>

        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
          <button className="btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn-primary" onClick={handleSubmit}>
            <CreditCard size={14} /> Add Subscription
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddSubscriptionModal;